import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useLanguageUrl } from '../utils/languageUtils';
import { getImageUrl } from '../utils/imageUtils';

const Footer = () => {
  const { t } = useTranslation();
  const { getLanguageUrl } = useLanguageUrl();

  return (
    <footer className="bg-white border-t">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between">
          <div className="flex items-center gap-3 mb-4 sm:mb-0">
            <div className="h-6 w-6 rounded-lg bg-gradient-to-br from-white to-white">
              <img 
                src={getImageUrl("/images/tapngrab_logo_s.png")} 
                alt="Tap'nGrab" 
                className="w-full h-full object-contain"
              />
            </div>
            <span className="text-sm text-slate-500">{t('footer.copyright')}</span>
          </div>
          
          <div className="flex items-center gap-6 text-sm text-slate-500">
            <Link to={getLanguageUrl('/privacy')} className="hover:text-slate-900">
              {t('footer.privacy')}
            </Link>
            <Link to={getLanguageUrl('/terms')} className="hover:text-slate-900">
              {t('footer.terms')}
            </Link>
            <Link to={getLanguageUrl('/cookies')} className="hover:text-slate-900">
              {t('footer.cookies')}
            </Link>
          </div>
        </div>
        <div className="mt-6 pt-6 border-t border-slate-200">
          <p className="text-xs text-slate-400 text-center">
            {t('footer.photo_disclaimer')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
